import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { setRouteTag } from "@/utils/sentryTags";

const SentryRouteTag = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    setRouteTag(pathname);
  }, [pathname]);

  return null;
};

export default SentryRouteTag;
